import React from 'react'
import { Maybe } from '../graphql-types'

/**
 * Used to pass down the index of the section the consumer is in
 */
export const SectionContext = React.createContext<Maybe<number>>(null)
